import EmptyState from '../components/EmptyState';

export default function Agents() {
  return (
    <EmptyState
      title="Agents"
      description="EventBridge-scheduled agent jobs and execution history"
    />
  );
}
